// extracted by mini-css-extract-plugin
module.exports = {"skeletonInput":"style_skeletonInput__3x09h","shimmer":"style_shimmer__KKqSR"};